<template>
    <div class="kombi-tooltip">
        <div class="tooltip-header">
            Carrinho Compartilhado
        </div>
        <Loader v-if="loading"/>
        <div v-else-if="!loading" class="tooltip-body">
            <div  class="row">
                <div  class="col-md-12">
                    <div class="product-list">
                        <table style="width:100%">
                            <tr v-for="(kombi, index) in kombiList" :key="'tooltip-prod' + index" class="tooltip-table-data"
                                :style="kombi.selected ? 'background: #aef1ae' : ''">
                                <td class="text-center">
                                    <a class="fa fa-times fa-lg" style="color:red" v-on:click.prevent="deleteAction(kombi.code)"/>
                                </td>
                                <td class="tooltip-description">
                                    <strong>Código: </strong>{{kombi.code}}
                                    <br>
                                    <strong>Valor total: </strong>{{formatCurrency(kombi.value)}}
                                    <br>
                                    <strong>Data de Faturamento: </strong>{{ kombi.dataFaturamento }}
                                </td>
                                <td class="text-center">
                                    <button aria-label="Abrir carrinho" type="button" @click="setCodigoPedido(kombi)" class="btn btn-primary">Abrir carrinho</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Loader from '../Loader';
import axios from 'axios';

export default {
    name: "KombiListTooltip",
    props: [ 'kombiList' ],
    mounted(){
    },
    computed: {
        totalKombi: function() {
            let sum = 0;
            this.kombiList.forEach((element) => {
                sum += element.value;
            })
            return sum;
        }
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {
        formatCurrency: function(v) {
            //formata valores floats para moeda
            var formato = {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL"
            };
            return parseFloat(v).toLocaleString("pt-BR", formato);
        },
        setCodigoPedido(kombi) {
            axios.get(`${this.$apiUrl}Carrinho.svc/SetarSessionPedido/${kombi.code}`, { withCredentials: true })
            .then((response) => {
                localStorage.removeItem('formaPagamento');
                localStorage.removeItem('meioPagamento');
                localStorage.parcelaSelecionada = 'Parcelas';
                location.href = kombi.vendaDireta ? this.$SiteUrl + "/loja/meu-carrinho-venda-direta/carrinho" : this.$SiteUrl + "/loja/meu-carrinho/carrinho"
            })
        },
        deleteAction: function(codigoPedido){
            const self = this
            swal({
                title: "Exclusão do carrinho",
                text: "Deseja excluir o carrinho " + codigoPedido + "?",
                buttons: ["Cancelar", "Excluir"],
                dangerMode: true,
                })
            .then((willDelete) => {
                if (willDelete) {
                    // console.log("Deletando carrinho...", willDelete);
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200){
                            // console.log("Deletando carrinho...", willDelete);
                            if(xhr.responseText != "" && xhr.responseText != null){
                                let json = JSON.parse(xhr.responseText);
                                // console.log("Result(deletar carrinho): ", xhr.responseText);
                                localStorage.vendedor = "INTERNET";
                                localStorage.formaPagamento = "vista";
                                localStorage.meioPagamento = 'Boleto'
                                localStorage.numCartaoBNDS = ''
                                localStorage.validadeBNDS = ''
                                localStorage.bandeiraBNDS = ''
                                localStorage.bancoBNDS = ''
                                localStorage.parcelaBNDS = ''
                                localStorage.parcelaSelecionada = 'Parcelas';
                                localStorage.cifKombi = ''
                                localStorage.fobKombi = ''

                                location.href = `${self.$SiteUrl}/loja`;
                            }
                        } else {
                            // console.log("state:", xhr.readyState, " status:", xhr.status);
                        }
                    }
                    xhr.open("POST", this.$apiUrl + "Carrinho.svc/CancelarPedido");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({
                        codigoPedido: codigoPedido,
                    }));
                }else{
                    return;
                }
            });
        },
    }
}
</script>

